//import getJSONData and setJSONData from Toolkit
import{getJSONData, sendJSONData} from "./../lib/Toolkit";

//the json file used for all data
let jsonScript = "Tip Amounts.json";

//the JSON response object
let json;

//number of days in the JSON object
let dayCount;

//the dates dropdown
let lstDates;

//------------------------------------------PRIVATE FUNCTIONS
function populateDropdown(){
    for (let i=0; i<dayCount; i++){
        let option = document.createElement("option");
        option.text = json.days[i].date;
        option.id = i;
        lstDates.add(option);
    }

    lstDates.addEventListener("change", onChanged);

}

function calculateTPA(tips,hours){
    let tpa = tips / hours;
    let roundedTPA = round(tpa,2);
    return roundedTPA;
}

function round(value,decimals){
    //this function exists to round a decimal to certain point
    //this was taken from http://www.jacklmoore.com/notes/rounding-in-javascript/
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
//------------------------------------------EVENT HANDLERS
function onChanged(){
    let listItem = lstDates.selectedOptions[0];
    let optionID = listItem.id;
    let tips = json.days[optionID].money;
    let hours = json.days[optionID].hours;

    console.log(optionID);
    document.getElementsByClassName("data__tips")[0].innerHTML = "Total Money: $" + tips;
    document.getElementsByClassName("data__hours")[0].innerHTML = "Total Hours: " + hours;

    let tpa = calculateTPA(tips,hours);

    document.getElementsByClassName("data__total")[0].innerHTML = "You made $" + tips + " in tips over " + hours + " hours of work. <br> You've made $" + tpa + " per hour.";

    
}

function onResponse(result){
    //console.log("Response Received! " + result);

    //turn the string file into array of objects list
    json = JSON.parse(result);
    console.log(json);

    dayCount = json.days.length;
    console.log("Days Found: " + dayCount);
    if (dayCount > 0){
        populateDropdown();
        onChanged();
    }
}

function onTotal(){
    if (document.querySelectorAll("[type=button]")[0].value == "Show Grand Total"){
        let totalTips = 0;
        let totalHours = 0;
        for (let i=0; i<dayCount; i++){
            totalTips += parseInt(json.days[i].money);
            totalHours += parseInt(json.days[i].hours);
        }
        //console.log("Money: " + totalTips);
        //console.log("Hours: " + totalHours);
        let totalTPA = calculateTPA(totalTips,totalHours);
        document.getElementsByClassName("total__results")[0].innerHTML = "You've made $" + totalTips + " in tips over " + totalHours + " hours of work. <br>This leads to an average of $" + totalTPA + " per hour.";

        document.querySelectorAll("[type=button]")[0].value = "Hide Grand Total";
    } else {
        document.getElementsByClassName("total__results")[0].innerHTML = "";
        document.querySelectorAll("[type=button]")[0].value = "Show Grand Total";
    }
}

function onTipSection(){
    if (document.querySelectorAll("[type=button]")[1].value == "Show Tip Intervals"){
        //underOne is any amount below $1
        let underOne = 0;
        //lowerOne is any amount between $1 and $1.49
        let lowerOne = 0;
        //highOne is any amount between $1.50 and $1.99
        let highOne = 0;
        //aboveTwo is any amount above $2
        let aboveTwo = 0;

        for (let i=0; i<dayCount; i++){
            let data = calculateTPA(json.days[i].money,json.days[i].hours);
            if (data < 1.00){
                underOne++;
            } else if (data >= 1.00 && data <= 1.49){
                lowerOne++;
            } else if (data >= 1.50 && data <= 1.99){
                highOne++;
            } else if (data >= 2.00){
                aboveTwo++;
            }
        }

        //console.log(underOne, lowerOne, highOne , aboveTwo);
        document.getElementsByClassName("tipSection__results")[0].innerHTML =  "In " + dayCount + " days: <br> You had an average of under $1 per hour for " + underOne + " days, <br> an average between $1 and $1.49 for " + lowerOne + " days, <br> an average of $1.50 and $1.99 for " + highOne + " days, <br> and an average of over $2 for " + aboveTwo + " days.";

        document.querySelectorAll("[type=button]")[1].value = "Hide Tip Intervals";
    } else {
        document.getElementsByClassName("tipSection__results")[0].innerHTML = "";
        document.querySelectorAll("[type=button]")[1].value = "Show Tip Intervals";
    }
}

function onHourSection(){
    if (document.querySelectorAll("[type=button]")[2].value == "Show Hour Intervals"){
        //noBreak is any hours below 4.5
        let noBreak = 0;
        //oneBreak is any amount above 4.5 and below 6
        let oneBreak = 0;
        //oneLongBreak is any amount above 6 and below 8
        let oneLongBreak = 0;
        //twoBreak is any amount above 8 and below 10
        let twoBreak = 0;
        //twoLongBreak is any amount above 10 hours
        let twoLongBreak = 0;

        for (let i=0; i<dayCount; i++){
            let data = json.days[i].hours;
            if (data < 4.5){
                noBreak++;
            } else if (data >= 4.5 && data < 6){
                oneBreak++;
            } else if (data >= 6 && data < 8){
                oneLongBreak++;
            } else if (data >= 8 && data < 10){
                twoBreak++;
            } else if (data >= 10){
                twoLongBreak++;
            }
        }

        //console.log(noBreak, oneBreak, oneLongBreak , twoBreak, twoLongBreak);
        document.getElementsByClassName("hourSection__results")[0].innerHTML =  "In " + dayCount + " days: <br> You worked under 4.5 hours for " + noBreak + " days, <br> above 4.5 and under 6 for " + oneBreak + " days, <br> above 6 and under 8 for " + oneLongBreak + " days, <br> above 8 and under 10 for " + twoBreak + " days, <br> and over 10 hours for " + twoLongBreak + " days.";

        document.querySelectorAll("[type=button]")[2].value = "Hide Hour Intervals";
    } else {
        document.getElementsByClassName("hourSection__results")[0].innerHTML = "";
        document.querySelectorAll("[type=button]")[2].value = "Show Hour Intervals";
    }
}

/*function addDate(){
    let date = document.getElementById("txtDate").value;
    let money = document.getElementById("txtMoney").value;
    let hours = document.getElementById("txtHours").value;
    console.log(date,money,hours);
    
    let sendJSON = {
        "date": date,
        "money": money,
        "hours": hours,
    };

    //convert the JSON field into a string
    let sendString = JSON.stringify(sendJSON);

    //send the data to the JSON file
    sendJSONData(json, sendString, onSubmit, onError);

}

function onSubmit(responseText){
    //when a comment it submitted
    //a loading screen will need to be included here
    console.log(`Response Received! ${responseText}`);
    location.reload();
}
*/
function onError(message) {
    console.log(`*** Error has occured | Message: ${message}`);
}
//------------------------------------------MAIN FUNCTION
function main(){ 
    lstDates = document.getElementById("lstDates");
    getJSONData(jsonScript,onResponse,onError);

    let showTotal = document.querySelectorAll("[type=button]")[0];
    showTotal.addEventListener("click", onTotal);
    let tipSectionTotal = document.querySelectorAll("[type=button]")[1];
    tipSectionTotal.addEventListener("click", onTipSection);
    let hourSectionTotal = document.querySelectorAll("[type=button]")[2];
    hourSectionTotal.addEventListener("click", onHourSection);

    /*
    let submitDate = document.querySelectorAll("[type=button]")[1];
    submitDate.addEventListener("click",addDate);
    */
}

main();